export enum PaymentStatusEnum{
    PAID  = 'PAID',
    NOT_PAID  = 'NOT PAID'
}